import React from "react";
import { Route, Redirect } from "react-router-dom";

const PrivateRouteResults = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        localStorage.getItem("question_page_token") !== null ? (
          <Component {...props} />
        ) : (
          <Redirect to="/" />
        )
      }
    />
  );
};

export default PrivateRouteResults;
